import { render, staticRenderFns } from "./FacilityLocation.vue?vue&type=template&id=023656f2&"
import script from "./FacilityLocation.vue?vue&type=script&lang=js&"
export * from "./FacilityLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports